
export const modules = [
  'search-term',
  'fixed-attribute',
  'agreement-percentage'
]
